import { render, staticRenderFns } from "./myAdvice.vue?vue&type=template&id=e757e096&scoped=true"
import script from "./myAdvice.vue?vue&type=script&lang=js"
export * from "./myAdvice.vue?vue&type=script&lang=js"
import style0 from "./myAdvice.vue?vue&type=style&index=0&id=e757e096&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e757e096",
  null
  
)

export default component.exports